import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const signupUser = createAsyncThunk(
  "users/signupUser",
  async (
    {
      firstName,
      lastName,
      userName,
      email,
      phoneNumber,
      password,
      role_id,
      enrollment_center_id,
    },
    thunkAPI,
  ) => {
    try {
      const lowerCaseEmail = email.toLowerCase();
      const response = await fetch(
        "https://idms-preenrol.e-citizen.org/api/v1/auth/registration",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            firstName,
            lastName,
            userName,
            email: lowerCaseEmail,
            phoneNumber,
            role_id,
            enrollment_center_id,
            password,
          }),
        },
      );

      // Ensure data is correctly parsed as JSON
      let data = await response.json();
      console.log("data", data); // Inspect the data structure

      // If the response is OK (status in the range 200-299)
      if (response.ok) {
        // Return the full data object
        return thunkAPI.fulfillWithValue(data);
      } else {
        // If response is not OK, return the error data
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log("Error", e.response?.data || e.message); // Catch network errors
      return thunkAPI.rejectWithValue(e.response?.data || e.message);
    }
  },
);

export const loginUser = createAsyncThunk(
  "users/login",
  async ({ email, password }, thunkAPI) => {
    try {
      localStorage.setItem("email", email);
      const lowerCaseEmail = email.toLowerCase();
      const response = await fetch(
        "https://idms-preenrol.e-citizen.org/api/v1/auth/login",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: lowerCaseEmail,
            password,
          }),
        },
      );

      const data = await response.json();
      console.log("response");
      console.log(response);

      // Check if response status is successful
      if (response.ok) {
        // This checks if status is in the range 200-299
        if (data.success === "true") {
          // Use === for comparison, assuming your API returns a boolean
          console.log("I Am logged in");
          return thunkAPI.fulfillWithValue(data);
        }
      }

      // If we get here, something went wrong
      return thunkAPI.rejectWithValue(data);
    } catch (e) {
      console.log("Error", e);
      return thunkAPI.rejectWithValue(e.response?.data || "An error occurred");
    }
  },
);

export const sendOtp = createAsyncThunk(
  "users/sendOtp",
  async ({ otp }, thunkAPI) => {
    try {
      const email = localStorage.getItem("email");
      if (!email) {
        throw new Error("Email not found in storage");
      }

      const response = await fetch(
        "https://idms-preenrol.e-citizen.org/api/v1/auth/verifyOtp",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, otp }),
        },
      );

      // Read the response data once
      let responseData;
      try {
        responseData = await response.json();
      } catch (e) {
        return thunkAPI.rejectWithValue({
          message: responseData.message,
        });
      }

      // Check if response is not ok
      if (!response.ok) {
        return thunkAPI.rejectWithValue({
          message: responseData.message || "Verification failed",
        });
      }

      // Handle successful response
      if (responseData && responseData.jwtToken) {
        // Store the necessary data in localStorage
        localStorage.setItem("token", responseData.jwtToken);
        localStorage.setItem("email", responseData.email);
        localStorage.setItem("user_id", 1);
        localStorage.setItem("trackingIDFromServer", responseData.trackingId);
        localStorage.setItem("firstNameFromServer", responseData.firstName);
        localStorage.setItem("lastNameFromServer", responseData.lastName);

        // Safely store biodata-related items
        if (responseData.biodata) {
          localStorage.setItem("biodata_status", responseData.biodata.status);
          localStorage.setItem("sin", responseData.biodata.sin);
        }

        return responseData;
      } else {
        return thunkAPI.rejectWithValue({
          message: "Invalid response format from server",
        });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue({
        message: error.message || "Failed to verify OTP",
      });
    }
  },
);

export const editUser = createAsyncThunk(
  "users/editUser",
  async (
    {
      title,
      firstName,
      lastName,
      otherName,
      dob,
      gender,
      phoneNumber,
      trackId,
      nin,
      bvn,
      indegene,
      originState,
      lgId,
      WardId,
      houseAddress,
      residenceState,
      residenceLGA,
      industryId,
      specialtyId,
      maritalStatus,
      housingCondition,
      ownHouse,
      rentCost,
      houseCost,
      spokenLanguage,
      hasComputer,
      hasInternetSubscription,
      educationLevel,
      withDisability,
      disabilityType,
      withHealthInsurance,
      employmentStatus,
      ownBusiness,
      noOfBusiness,
      monthlyTurnover,
      businessAddress,
      annualTurnover,
      tin,
      timeToOffice,
      transportMeans,
      dailyExpenses,
      totalIncome,
      nokFirstName,
      nokOtherName,
      nokLastName,
      nokRelationship,
      nokPhone,
      nokAddress,
      user_id,
      countryResidence,
      countryOrigin,
      religion,
      enrolledBy,
      province,
      region,
      district,
      enrolmentType,
      parentDob,
      parentFirstName,
      parentNUI,
      parentLastName,
      contactOwner,
      maidenName,
      email,
      country,
      placeOfBirth,
      residenceAddress,
      modificationData,
      nui,
    },
    thunkAPI,
  ) => {
    try {
      const currentDate = new Date();

      // Extract individual components of the date and time
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
      const day = currentDate.getDate();
      const hours = currentDate.getHours();
      const minutes = currentDate.getMinutes();
      const seconds = currentDate.getSeconds();

      // Format the date and time as desired
      const formattedDateTime = `${year}${month}${day}${hours}${minutes}${seconds}`;
      const generateTrackingId = () => {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let result = "";
        for (let i = 0; i < 14; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * characters.length),
          );
        }
        return result;
      };
      // const trackingId = firstName + lastName + formattedDateTime;
      const trackingId = generateTrackingId;
      // localStorage.setItem("trackingIDFromServer", generateTrackingId);
      const token = localStorage.getItem("token");
      const response = await fetch(
        // "https://idms-preenrol.e-citizen.org/api/v1/enrolment/new",
        "https://idms-preenrol.e-citizen.org/api/v1/encryption/encrypt",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: {
              // title: "Mr",
              firstName,
              lastName,
              otherName,
              dob: localStorage.getItem("dan"),
              gender,
              phoneNumber,
              trackId: generateTrackingId(),
              nin,
              // bvn,
              // indegene: true,
              // originState: "10",
              // lgId: "10A",
              // WardId: "1",
              houseAddress,
              // residenceState: "1",
              // residenceLGA: "1",
              // industryId: "10",
              // specialtyId: "10A",
              maritalStatus,
              // housingCondition: "good",
              // ownHouse: false,
              // rentCost: 2000000,
              // houseCost: 0.0,
              // spokenLanguage,
              // hasComputer: true,
              // hasInternetSubscription: true,
              // educationLevel,
              // withDisability: false,
              // disabilityType,
              // withHealthInsurance,
              // employmentStatus: "Student",
              // ownBusiness: true,
              // noOfBusiness: 2,
              // monthlyTurnover: 40000.0,
              // businessAddress: "Lakechad Crescent",
              // annualTurnover: 5000000000.0,
              // tin: 4000.0,
              // timeToOffice: "2",
              // transportMeans,
              // dailyExpenses: 300,
              // totalIncome: 2000.0,
              nokFirstName,
              nokOtherName: "raymond",
              // nokLastName,
              // nokRelationship,
              // nokPhone,
              // nokAddress,
              enrolledBy: 1,
              religion,
              countryResidence,
              countryOrigin: "Ghana",
              user_id: 1,
              device_id: 0,
              trackingId: generateTrackingId,
              province,
              region,
              district,
              enrolmentType,
              parentDob: localStorage.getItem("dan"),
              parentFirstName,
              parentNUI,
              parentLastName,
              contactOwner,
              maidenName,
              email,
              country,
              placeOfBirth,
              residenceAddress,
              modificationData,
              nui,
            },
          }),
        },
      );
      let data = await response.json();
      console.log("data", data);

      if (response.status === 200) {
        try {
          const token = localStorage.getItem("token");
          const trackingID = localStorage.getItem("trackingIDFromServer");
          const secondResponse = await fetch(
            `https://idms-preenrol.e-citizen.org/api/v1/enrolment/update/${trackingID}`,
            {
              method: "PUT",
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            },
          );
          console.log("secondResponse");
          console.log(secondResponse);

          if (secondResponse.ok) {
            console.log("Data successfully sent to second endpoint");

            let data2 = await secondResponse.json();
            console.log(data2);
            localStorage.setItem("statusCode", data2.statusCode);
            localStorage.setItem("sin", data2.SIN);
            localStorage.setItem("citizenId", data2.id);
            localStorage.setItem("firstName", data2.firstName);
            localStorage.setItem("lastName", data2.lastName);
            localStorage.setItem("phoneNumber", data2.phoneNumber);
            localStorage.setItem("countryResidence", data2.countryResidence);
            localStorage.setItem("dob", data2.dob);
            localStorage.setItem("residenceAddress", data2.residenceAddress);
            localStorage.setItem("originState", data2.originState);
            localStorage.setItem("gender", data2.gender);
            localStorage.setItem("trackingId", data2.trackingId);
            localStorage.setItem("province", data2.province);
            localStorage.setItem("district", data2.district);
            localStorage.setItem("region", data2.region);
            localStorage.setItem("email", data2.email);
            localStorage.setItem("maidenName", data2.maidenName);
            localStorage.setItem("contactOwner", data2.contactOwner);
            localStorage.setItem("enrolmentType", data2.enrolmentType);
            localStorage.setItem("placeOfBirth", data2.placeOfBirth);
            localStorage.setItem("parentFirstName", data2.parentFirstName);
            localStorage.setItem("parentLastName", data2.parentLastName);
            localStorage.setItem("parentNUI", data2.parentNUI);
            localStorage.setItem("parentDob", data2.parentDob);
          } else {
            console.error("Failed to send data to second endpoint");
          }
        } catch (error) {
          console.error("Error sending data to second endpoint:", error);
        }
        return { data };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const enrolUser = createAsyncThunk(
  "users/enrolUser",
  async (
    {
      title,
      firstName,
      lastName,
      otherName,
      dob,
      gender,
      phoneNumber,
      trackId,
      nin,
      bvn,
      indegene,
      originState,
      lgId,
      WardId,
      houseAddress,
      residenceState,
      residenceLGA,
      industryId,
      specialtyId,
      maritalStatus,
      housingCondition,
      ownHouse,
      rentCost,
      houseCost,
      spokenLanguage,
      hasComputer,
      hasInternetSubscription,
      educationLevel,
      withDisability,
      disabilityType,
      withHealthInsurance,
      employmentStatus,
      ownBusiness,
      noOfBusiness,
      monthlyTurnover,
      businessAddress,
      annualTurnover,
      tin,
      timeToOffice,
      transportMeans,
      dailyExpenses,
      totalIncome,
      nokFirstName,
      nokOtherName,
      nokLastName,
      nokRelationship,
      nokPhone,
      nokAddress,
      user_id,
      countryResidence,
      countryOrigin,
      religion,
      enrolledBy,
      province,
      region,
      district,
      enrolmentType,
      parentDob,
      parentFirstName,
      parentNUI,
      parentLastName,
      contactOwner,
      maidenName,
      email,
      country,
      placeOfBirth,
      residenceAddress,
      modificationData,
      nui,
    },
    thunkAPI,
  ) => {
    try {
      const currentDate = new Date();

      // Extract individual components of the date and time
      const year = currentDate.getFullYear();
      const month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
      const day = currentDate.getDate();
      const hours = currentDate.getHours();
      const minutes = currentDate.getMinutes();
      const seconds = currentDate.getSeconds();

      // Format the date and time as desired
      const formattedDateTime = `${year}${month}${day}${hours}${minutes}${seconds}`;
      const generateTrackingId = () => {
        const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let result = "";
        for (let i = 0; i < 14; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * characters.length),
          );
        }
        return result;
      };
      // const trackingId = firstName + lastName + formattedDateTime;
      // const trackingId = generateTrackingId;
      localStorage.setItem("trackingId", generateTrackingId);
      console.log("generateTrackingId");
      console.log(generateTrackingId());

      const token = localStorage.getItem("token");
      const myGenerateTrackingId = generateTrackingId();

      const response = await fetch(
        // "https://idms-preenrol.e-citizen.org/api/v1/enrolment/new",
        "https://idms-preenrol.e-citizen.org/api/v1/encryption/encrypt",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: {
              // title: "Mr",
              firstName,
              lastName,
              otherName,
              dob: localStorage.getItem("dan"),
              gender,
              phoneNumber,
              trackId: myGenerateTrackingId,
              nin,
              // bvn,
              // indegene: true,
              // originState: "10",
              // lgId: "10A",
              // WardId: "1",
              houseAddress,
              // residenceState: "1",
              // residenceLGA: "1",
              // industryId: "10",
              // specialtyId: "10A",
              maritalStatus,
              // housingCondition: "good",
              // ownHouse: false,
              // rentCost: 2000000,
              // houseCost: 0.0,
              // spokenLanguage,
              // hasComputer: true,
              // hasInternetSubscription: true,
              // educationLevel,
              // withDisability: false,
              // disabilityType,
              // withHealthInsurance,
              // employmentStatus: "Student",
              // ownBusiness: true,
              // noOfBusiness: 2,
              // monthlyTurnover: 40000.0,
              // businessAddress: "Lakechad Crescent",
              // annualTurnover: 5000000000.0,
              // tin: 4000.0,
              // timeToOffice: "2",
              // transportMeans,
              // dailyExpenses: 300,
              // totalIncome: 2000.0,
              nokFirstName,
              nokOtherName: "raymond",
              // nokLastName,
              // nokRelationship,
              // nokPhone,
              // nokAddress,
              enrolledBy: 1,
              religion,
              countryResidence,
              countryOrigin: "Ghana",
              user_id: 1,
              device_id: 0,
              trackingId: generateTrackingId,
              province,
              region,
              district,
              enrolmentType,
              parentDob: localStorage.getItem("dan"),
              parentFirstName,
              parentNUI,
              parentLastName,
              contactOwner,
              maidenName,
              email,
              country,
              placeOfBirth,
              residenceAddress,
              modificationData,
              nui,
            },
          }),
        },
      );
      let data = await response.json();
      console.log("data", data);

      if (response.status === 200) {
        try {
          const token = localStorage.getItem("token");
          const secondResponse = await fetch(
            "https://idms-preenrol.e-citizen.org/api/v1/enrolment/new",
            {
              method: "POST",
              headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            },
          );
          console.log("secondResponse");
          console.log(secondResponse);

          if (secondResponse.ok) {
            console.log("Data successfully sent to second endpoint");

            let data2 = await secondResponse.json();
            console.log(data2);
            // console.log("myGenerateTrackingId", myGenerateTrackingId);

            localStorage.setItem("trackingIDFromServer", data2.trackingId);
            localStorage.setItem("statusCode", data2.statusCode);
            localStorage.setItem("sin", data2.SIN);
            localStorage.setItem("citizenId", data2.id);
            localStorage.setItem("firstName", data2.firstName);
            localStorage.setItem("lastName", data2.lastName);
            localStorage.setItem("phoneNumber", data2.phoneNumber);
            localStorage.setItem("countryResidence", data2.countryResidence);
            localStorage.setItem("dob", data2.dob);
            localStorage.setItem("residenceAddress", data2.residenceAddress);
            localStorage.setItem("originState", data2.originState);
            localStorage.setItem("gender", data2.gender);
            localStorage.setItem("trackingId", data2.trackingId);
            localStorage.setItem("province", data2.province);
            localStorage.setItem("district", data2.district);
            localStorage.setItem("region", data2.region);
            localStorage.setItem("email", data2.email);
            localStorage.setItem("maidenName", data2.maidenName);
            localStorage.setItem("contactOwner", data2.contactOwner);
            localStorage.setItem("enrolmentType", data2.enrolmentType);
            localStorage.setItem("placeOfBirth", data2.placeOfBirth);
            localStorage.setItem("parentFirstName", data2.parentFirstName);
            localStorage.setItem("parentLastName", data2.parentLastName);
            localStorage.setItem("parentNUI", data2.parentNUI);
            localStorage.setItem("parentDob", data2.parentDob);
          } else {
            console.error("Failed to send data to second endpoint");
          }
        } catch (error) {
          console.error("Error sending data to second endpoint:", error);
        }
        return { data };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async (
    {
      title,
      firstName,
      lastName,
      otherName,
      dob,
      gender,
      email,
      phoneNumber,
      trackId,
      nin,
      bvn,
      indegene,
      originState,
      lgId,
      WardId,
      houseAddress,
      residenceState,
      residenceLGA,
      industryId,
      specialtyId,
      maritalStatus,
      housingCondition,
      ownHouse,
      rentCost,
      houseCost,
      spokenLanguage,
      hasComputer,
      hasInternetSubscription,
      educationLevel,
      withDisability,
      disabilityType,
      withHealthInsurance,
      employmentStatus,
      ownBusiness,
      noOfBusiness,
      monthlyTurnover,
      businessAddress,
      annualTurnover,
      tin,
      timeToOffice,
      transportMeans,
      dailyExpenses,
      totalIncome,
      nokFirstName,
      nokOtherName,
      nokLastName,
      nokRelationship,
      nokPhone,
      nokAddress,
      user_id,
      countryResidence,
      countryOrigin,
      religion,
      enrolledBy,
      province,
      region,
      district,
      placeOfBirth,
    },
    thunkAPI,
  ) => {
    try {
      const response = await fetch(
        "https://idms-preenrol.e-citizen.org/api/v1/biodata/update/" +
          localStorage.getItem("biodata_id"),
        {
          method: "PUT",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            title: "Mr",
            firstName,
            lastName,
            otherName,
            dob: localStorage.getItem("dan"),
            gender,
            email,
            phoneNumber,
            trackId,
            // nin,
            bvn,
            indegene: true,
            originState: "1",
            lgId: "1",
            WardId: "1",
            houseAddress,
            residenceState: "1",
            residenceLGA: "1",
            industryId: "1",
            specialtyId: "1",
            maritalStatus,
            housingCondition: "good",
            ownHouse: false,
            rentCost: 2000000,
            houseCost: 0.0,
            spokenLanguage,
            hasComputer: true,
            hasInternetSubscription: true,
            educationLevel,
            withDisability: false,
            disabilityType,
            withHealthInsurance,
            employmentStatus: "Student",
            ownBusiness: true,
            noOfBusiness: 2,
            monthlyTurnover: 40000.0,
            businessAddress: "Lakechad Crescent",
            annualTurnover: 5000000000.0,
            tin: 4000.0,
            timeToOffice: "2",
            transportMeans,
            dailyExpenses: 300,
            totalIncome: 2000.0,
            nokFirstName,
            nokOtherName: "raymond",
            nokLastName,
            nokRelationship,
            nokPhone,
            nokAddress,
            enrolledBy: 1,
            religion,
            countryResidence,
            countryOrigin: "Nigeria",
            user_id: 1,
            province,
            region,
            district,
          }),
        },
      );
      let data = await response.json();
      console.log("data", data);

      if (response.status === 200) {
        return { data };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const fetchUserBytoken = createAsyncThunk(
  "users/fetchUserByToken",
  async ({ token }, thunkAPI) => {
    try {
      const response = await fetch(
        "https://idms-preenrol.e-citizen.org/api/v1/users/admin_list",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: token,
            "Content-Type": "application/json",
          },
        },
      );
      let data = await response.json();
      console.log("data", data, response.status);

      if (response.status === 200) {
        return { ...data };
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const fetchUserBySin = createAsyncThunk(
  "users/fetchUserBySin",
  async ({ trackingId }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `https://idms-preenrol.e-citizen.org/api/v1/enrolment/trackingId/${trackingId}`,
        // 'http://192.168.0.2:8064/enrollees/register',
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );
      let data = await response.json();
      console.log("data", data);
      return data;
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const fetchUserByNui = createAsyncThunk(
  "users/fetchUserByNui",
  async ({ nui }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        "https://localhost:8071/api/v1/personaldata/get-enrolment",
        { nui },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-BC-API-Key": "b7F!z9vQ2sG#LxP@Yt3KdN$wM5XpV&C8",
          },
        },
      );

      // Check for non-2xx status codes
      if (response.status >= 200 && response.status < 300) {
        return response.data;
      } else {
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      console.log("Error", e.response?.data);
      return thunkAPI.rejectWithValue(e.response?.data);
    }
  },
);

export const userSlice = createSlice({
  name: "user",
  initialState: {
    username: "",
    email: "",
    phoneNumber: "",
    firstname: "",
    lastName: "",
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
    successMessage: "SUCCESSFUL",
    role_id: "",
    enrollment_center_id: "",
    province: "",
    region: "",
    district: "",

    otherName: "",
    dob: "",
    gender: "",
    trackId: "",
    nin: "",
    bvn: "",
    indegene: "",
    originState: "",
    lgId: "",
    WardId: "",
    houseAddress: "",
    residenceState: "",
    residenceLGA: "",
    industryId: "",
    specialtyId: "",
    maritalStatus: "",
    housingCondition: "",
    ownHouse: "",
    rentCost: "",
    houseCost: "",
    spokenLanguage: "",
    hasComputer: "",
    hasInternetSubscription: "",
    educationLevel: "",
    withDisability: "",
    disabilityType: "",
    withHealthInsurance: "",
    employmentStatus: "",
    ownBusiness: "",
    noOfBusiness: "",
    monthlyTurnover: "",
    businessAddress: "",
    annualTurnover: "",
    tin: "",
    timeToOffice: "",
    transportMeans: "",
    dailyExpenses: "",
    totalIncome: "",
    nokFirstName: "",
    nokOtherName: "",
    nokLastName: "",
    nokRelationship: "",
    nokPhone: "",
    nokAddress: "",
    user_id: "",
    countryResidence: "",
    countryOrigin: "",
    religion: "",
    enrolledBy: "",
    sin: "",
    userData: null,
  },
  reducers: {
    clearState: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isFetching = false;

      return state;
    },
  },
  extraReducers: {
    [signupUser.fulfilled]: (state, { payload }) => {
      console.log("payloadSignUp", payload);
      state.isFetching = false;
      state.isSuccess = true;
      state.successMessage = payload?.message || "Sign up successful";
    },
    [signupUser.pending]: (state) => {
      state.isFetching = true;
    },
    [signupUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.isSuccess = false;
      state.errorMessage = payload?.message || "Failed to sign up";
    },
    [loginUser.fulfilled]: (state, { payload }) => {
      state.email = payload.email;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false; // Reset error state
      state.errorMessage = null; // Clear any error messages
    },
    [loginUser.rejected]: (state, { payload }) => {
      console.log("payload", payload);
      state.isFetching = false;
      state.isError = true;
      state.isSuccess = false; // Make sure to set success to false
      state.errorMessage = payload?.message || "Login failed"; // Set error message from payload
    },
    [loginUser.pending]: (state) => {
      state.isFetching = true;
      state.isError = false; // Reset error state
      state.isSuccess = false; // Reset success state
      state.errorMessage = null; // Clear any error messages
    },
    [sendOtp.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false;
      state.errorMessage = "";
    },
    [sendOtp.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.isSuccess = false;
      state.errorMessage = payload?.message || "Verification failed";
    },
    [sendOtp.pending]: (state) => {
      state.isFetching = true;
      state.isError = false;
      state.isSuccess = false;
      state.errorMessage = "";
    },
    [enrolUser.fulfilled]: (state, { payload }) => {
      // state.email = payload.email;
      // state.username = payload.username;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [enrolUser.rejected]: (state, { payload }) => {
      console.log("payload", payload);
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = "Opps... Something went wrong";
    },
    [enrolUser.pending]: (state) => {
      state.isFetching = true;
    },

    [editUser.fulfilled]: (state, { payload }) => {
      // state.email = payload.email;
      // state.username = payload.username;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [editUser.rejected]: (state, { payload }) => {
      console.log("payload", payload);
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = "Opps... Something went wrong";
    },
    [editUser.pending]: (state) => {
      state.isFetching = true;
    },
    [updateUser.fulfilled]: (state, { payload }) => {
      state.email = payload.email;
      state.username = payload.username;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [updateUser.rejected]: (state, { payload }) => {
      console.log("payload", payload);
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = "Opps... Something went wrong";
    },
    [updateUser.pending]: (state) => {
      state.isFetching = true;
    },
    [fetchUserBySin.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.errorMessage = "";
      // Store the entire payload in the state
      state.userData = payload;
    },
    [fetchUserBySin.rejected]: (state, { payload }) => {
      console.log("payload", payload);
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = "Opps... Something went wrong. Check Tracking ID";
    },
    [fetchUserBySin.pending]: (state) => {
      state.isFetching = true;
    },

    [fetchUserByNui.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.errorMessage = "";
      // Store the entire payload in the state
      state.userData = payload;
    },
    [fetchUserByNui.rejected]: (state, { payload }) => {
      console.log("payload", payload);
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = "Opps... Something went wrong. Check NUI";
    },
    [fetchUserByNui.pending]: (state) => {
      state.isFetching = true;
    },

    [fetchUserBytoken.pending]: (state) => {
      state.isFetching = true;
    },
    [fetchUserBytoken.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = false;

      state.email = payload.email;
      state.username = payload.username;
    },
    [fetchUserBytoken.rejected]: (state) => {
      console.log("fetchUserBytoken");
      state.isFetching = false;
      state.isError = true;
    },
  },
});

export const { clearState } = userSlice.actions;

export const userSelector = (state) => state.user;
